module.exports = __webpack_public_path__ + "static/media/connector-logo_airflow.e83aa2a6.svg";